import { useState, useCallback } from 'react';
import { get, post, put } from '../utils/networkUtils';

export const useAdminSettings = () => {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const fetchSettings = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await get('/admin/settings');
      setSettings(Array.isArray(response) ? response : []);
      return response;
    } catch (err) {
      console.error('Error fetching admin settings:', err);
      const message = err instanceof Error ? err.message : 'Failed to fetch admin settings';
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const saveSetting = useCallback(
    async ({ id, settingType, settingValue }) => {
      setSaving(true);
      setError(null);
      try {
        if (id) {
          await put(`/admin/settings/${id}`, { settingType, settingValue });
        } else {
          await post('/admin/settings', { settingType, settingValue });
        }
        await fetchSettings();
      } catch (err) {
        console.error('Error saving admin setting:', err);
        const message = err instanceof Error ? err.message : 'Failed to save admin setting';
        setError(message);
        throw err;
      } finally {
        setSaving(false);
      }
    },
    [fetchSettings]
  );

  return {
    settings,
    loading,
    saving,
    error,
    fetchSettings,
    saveSetting,
  };
};
